import { z } from "zod";

export const MAX_COA_CSV_LENGTH = 2_000_000;

export const mapCoaTypesCsvBodySchema = z.object({
    workspaceId: z.string().uuid(),
    file: z.string().min(1).max(MAX_COA_CSV_LENGTH),
});

export const mapCoaTypesCsvResponseSchema = z.object({
    file: z.string(),
    filename: z.string(),
});

export type MapCoaTypesCsvBody = z.infer<typeof mapCoaTypesCsvBodySchema>;
export type MapCoaTypesCsvResponse = z.infer<
    typeof mapCoaTypesCsvResponseSchema
>;
